import { Button, Menu, MenuItem, Fade, ClickAwayListener } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function DocumentsMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (route) => {
    handleClose();
    navigate(route);
  };

  return (
    <div>
      <ClickAwayListener onClickAway={handleClose}>
        <Button
          sx={{ my: 2, color: "white", display: "flex" }}
          onClick={handleOpen}
          endIcon={<ExpandMoreIcon />}
        >
          Dokument
        </Button>
      </ClickAwayListener>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        sx={{ mt: 2 }}
      >
        <MenuItem onClick={() => handleClick("/invoices")}>Fakturor</MenuItem>
        {/* 
        <MenuItem onClick={() => handleClick("/reminders")}>
          Påminnelser
        </MenuItem>
        <MenuItem onClick={() => handleClick("/interestinvoices")}>
          Räntefakturor
        </MenuItem>
        */}
      </Menu>
    </div>
  );
}
